import * as Yup from 'yup'
import i18n from 'i18next'

const schema = ({ min_amount, max_amount }) =>
  Yup.object().shape({
    wallet_id: Yup.number()
      .typeError('common::validation_messages.required')
      .required('common::validation_messages.required'),
    credit_period: Yup.number().required(
      'common::validation_messages.required',
    ),
    amount: Yup.string()
      .required('common::validation_messages.required')
      .test(
        'minMaxAmount',
        i18n.t(
          'promised_payment::request.fields.amount.validation_messages.incorrect_amount_min_max',
          {
            min_amount,
            max_amount,
          },
        ),
        function test(value) {
          let isValid

          const { path, createError } = this

          isValid =
            min_amount <= parseFloat(value) && parseFloat(value) <= max_amount

          return (
            isValid ||
            createError({
              path,
              message: i18n.t(
                'promised_payment::request.fields.amount.validation_messages.incorrect_amount_min_max',
                {
                  min_amount,
                  max_amount,
                },
              ),
            })
          )
        },
      ),
    apply_agreement: Yup.boolean()
      .oneOf([true], 'common::validation_messages.required')
      .required('common::validation_messages.required'),
  })

export default schema
